<template>
	<div class="Index" v-resize="resize">
		<!-- 头 -->
		<Head></Head>
		<!-- 内容 -->
		<router-view />
		<!-- 页脚 -->
		<Foot></Foot>
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			resize(e) {
				this.$set('mobile', e.width < 768)
			}
		}
	}
</script>

<style lang="scss">
	.Index {
		
	}
</style>
